import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalCursoRadiologia = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/jw4AoLGB2igYvmt96'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Curso de Radiología Torácica</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Inscripciones</p>
            <p className='fw-normal'>Desde el 24/02 hasta el 16/04 de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Inicio</p>
            <p className='fw-normal'>17 de abril de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Días</p>
            <p className='fw-normal'>Viernes 17 y sábado 18 de abril de 2026</p>
          </div>
          <div className='info-group mb-3'>
            <p className='heading-title-md fw-semibold mb-2'>Horario</p>
            <p className='fw-normal spaced-xs'>3:00 a 5:40 PM</p>
            <p className='fw-normal'>Facultad de Medicina</p>
          </div>

          <a className='btn btn-primary link-button mb-4' href={formLink} target='blank'>
            Formulario de Inscripción
          </a>

          <div className='info-group mt-3 mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Dr. Juan Lauretta</p>
            <p className='fw-semibold mb-0'>Coordinador</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalCursoRadiologia }